'use strict';

module.exports = require('./lib/');



//////////////////
// WEBPACK FOOTER
// ./~/remarkable/index.js
// module id = 1092
// module chunks = 0